import { createFileRoute } from '@tanstack/react-router';
import { InvitePage } from '@/features/auth/pages/invite-page';

export const Route = createFileRoute('/_auth/invite/$token')({
  validateSearch: (s: Record<string, unknown>): { error?: string } => ({
    error: typeof s.error === 'string' ? s.error : undefined,
  }),
  component: InvitePage,
});
